var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h3',{staticClass:"text-h4",staticStyle:{"margin-bottom":"30px"}},[_vm._v("Logging in...")]),_c('v-progress-circular',{attrs:{"size":100,"width":10,"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }